<template>
    <div
        :class="`convention-teaser-content ${mode} ${child ? 'child' : ''} ${
            selected ? 'selected' : ''
        }`"
    >
        <div class="line-selected" v-if="child && selected"></div>
        <v-row class="teaser-container" align="center">
            <v-col cols="8" sm="8">
                <convention-teaser-title :convention="convention" :mode="mode" />
                <convention-teaser-info :convention="convention" :mode="mode" />
                <convention-teaser-alert
                    v-if="!child && mode == 'dashboard'"
                    :convention="convention"
                    :mode="mode"
                />
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" v-for="variant in variants" :key="variant._uid">
                <convention-teaser-action
                    :selected="selectedVariantNumber == variant.variantNumber"
                    :convention="convention"
                    :variant="variant"
                    :mode="mode"
                    @type-mouseover="changeMouseOverType"
                    :mouseOverType="mouseOverType"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ConventionTeaserAlert from "./ConventionTeaserAlert.vue";
import ConventionTeaserTitle from "./ConventionTeaserTitle.vue";
import ConventionTeaserInfo from "./ConventionTeaserInfo.vue";
import ConventionTeaserAction from "./ConventionTeaserAction.vue";

import { chain } from "lodash";

export default {
    components: {
        ConventionTeaserAction,
        ConventionTeaserInfo,
        ConventionTeaserTitle,
        ConventionTeaserAlert,
    },
    props: ["mode", "child", "convention", "selected", "selectedVariantNumber"],
    data() {
        return {
            mouseOverType: null,
        };
    },
    computed: {
        dico() {
            return this.$privateDico.convention.teaser;
        },
        variants() {
            const rank = {
                syndiquee: 1,
                "non-syndiquee": 2,
                etendue: 3,
                "info-vns": 4,
            };
            const allVariants = chain(this.convention.allVariants)
                .map(v => ({ ...v, rank: rank[v.type] ? rank[v.type] : 0 }))
                .sortBy("rank")
                .value();
            if (this.convention.isHiddenInSearch) {
                const thisVariant = {
                    type: this.convention.type,
                    variantNumber: this.convention.variantNumber,
                };
                return [thisVariant, ...allVariants];
            }
            return allVariants;
        },
    },
    methods: {
        changeMouseOverType(type) {
            this.mouseOverType = type;
        },
    },
};
</script>

<style scoped lang="sass">

.convention-teaser-content
    margin-top: 10px
    padding: 10px 20px 10px 10px
    position: relative
    transition: opacity .3s ease-in
    padding-left: 10px
    box-sizing: border-box
    &:after
        content: ""
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        background: $color-secondary
        opacity: 0.5

    &.dashboard
        margin-top: 1px
        &:after
            border: 1px solid transparentize($color-secondary, 0.5)
            opacity: 1
            background: white

    &.child
        margin-top: 10px
        // display: none
        margin-left: 10px
        &:before
            content: ""
            border-left: 3px solid $color-secondary
            left: -10px
            top: 0px
            bottom: -10px
            width: 1px
            position: absolute
            opacity: 0.3

    &:last-child.child:before
        bottom: 0

    &.search-result
        &:after
            border: 1px solid transparentize($color-secondary, 0.5)
            opacity: 1
            background: white

    &.selected
        display: block
        &:after
            opacity: 1

.line-selected
    position: absolute
    border-left: 3px solid $color-secondary
    left: -10px
    top: 0px
    bottom: 0px
    width: 1px
    position: absolute

.teaser-container
    position: relative
    z-index: 1
</style>
